import { RmaSearchResponse } from '../../models/rma.models';

export interface RmaSummaryRow {
  rmaId: number;
  rmaNumber: string;
  rmaType: string;
  order: string;
  shipmentId: string;
  dcc: string;
  warehouse: string;
  status: string;
  compliance: string;
  channel: string;
  createdBy: string;
  date: string;
  lastUpdatedDate: string;
}

function formatSummaryDateTime(value: string | null | undefined): string {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
}

export function mapRmaSearchResponseToRow(
  response: RmaSearchResponse,
): RmaSummaryRow {
  const order = response.order;
  const shipmentIdValue =
    order?.shipment_id ??
    order?.shipment_number ??
    order?.shipment_Id ??
    response.shipment_id ??
    response.shipment_number ??
    response.shipment_Id;

  return {
    rmaId: response.rma_id,
    rmaNumber: response.rma_number ?? '',
    rmaType: response.rma_type ?? '',
    order: order?.web_order_id ?? response.web_order_id ?? '',
    shipmentId: shipmentIdValue == null ? '' : String(shipmentIdValue),
    dcc: order?.dcc_code ?? response.dcc_code ?? '',
    warehouse: order?.warehouse_code ?? response.warehouse_code ?? '',
    status: response.status ?? '',
    compliance: response.compliance_status ?? '',
    channel: order?.sales_channel_code ?? response.sales_channel_code ?? '',
    createdBy: response.created_by ?? '',
    date: formatSummaryDateTime(response.created_on),
    lastUpdatedDate: formatSummaryDateTime(response.updated_on),
  };
}
